import React from 'react';
import { Row, Col } from 'antd';
import LoginLayout from 'layouts/LoginLayout';
import LoginLogo from 'components/LoginLogo';

export default function LegalLoginShell({ children }) {
  return (
    <LoginLayout>
      <Row style={{ display: 'flex', flexWrap: 'nowrap', position: 'relative' }}>
        <Col
          xs={24}
          style={{ flex: '0 0 70%', maxWidth: '70%' }}
          className="loginLeftside"
        >
          {process.env.REACT_APP_THEME !== 'NETWORK_COMMANDER' && <LoginLogo />}
        </Col>
        <Col
          xs={24}
          style={{ flex: '0 0 30%', maxWidth: '30%' }}
          className="loginRightside legal-login-right"
        >
          {children}
        </Col>
      </Row>
    </LoginLayout>
  );
}
